export const checkIfAssetExists = (assetId, tableData) => {
  if (tableData?.Assets?.[assetId]) {
    return true
  } else {
    console.log("⛔️ asset doesnt exist")
    return false
  }
}